<template>
  <section v-if="enabled" id="sidebar" :class="{ active: isActive }" class="has-background-dark has-text-light" ref="sidebar">
    <button type="button" class="sidebar-toggle button is-dark has-background-black-bis" @click="toggle">
      <b-icon :icon="icon" type=""></b-icon>
    </button>
    <nav class="navbar has-background-black-ter" role="navigation" aria-label="dropdown navigation">
      <div class="navbar-brand title">
        <h1>{{ $app.name }}</h1>
        <span>{{ $app.version }}</span>
      </div>
      <div class="navbar-menu">
        <div class="navbar-end">
          <b-dropdown
            position="is-bottom-left"
            aria-role="menu">
            <a
              class="navbar-item"
              slot="trigger"
              role="button">
              <span></span>
              <b-icon icon="menu-down" type="is-white"></b-icon>
            </a>
            <b-dropdown-item custom aria-role="menuitem">
              {{ $t('login.logged_as') }} <b>{{ $store.getters['user'] }}</b>
            </b-dropdown-item>
            <b-dropdown-item has-link aria-role="menuitem">
              <a href="http://kappazeta.ee" target="_blank">
                KappaZeta
              </a>
            </b-dropdown-item>
            <hr class="dropdown-divider" aria-role="menuitem">
            <b-dropdown-item
              v-if="$store.getters.isLoggedIn"
              value="logout"
              aria-role="menuitem"
              @click="logout">
              {{ $t('login.logout') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </div>
    </nav>
    <dataselector-component />
    <div class="scroller">
      <div>
        <search-component v-if="$conf.search.enabled"/>
        <search-results-component v-if="isSearchResultsAvailable" />
        <map-filter-component v-if="!isSearchResultsAvailable" />
        <help-component v-if="!isSearchResultsAvailable" />
      </div>
    </div>
  </section>
</template>

<script>

import DataselectorComponent from './DataSelector'
import SearchComponent from './Search'
import SearchResultsComponent from './SearchResults'
import MapFilterComponent from 'comp/map/MapFilter'
import HelpComponent from 'comp/Help'

const breakPoint = 768
const dimensions = {
  left: 350,
  bottom: 450
}

export default {
  name: 'SidebarComponent',
  components: {
    DataselectorComponent,
    SearchComponent,
    MapFilterComponent,
    SearchResultsComponent,
    HelpComponent
  },
  data () {
    return {
      position: window.innerWidth >= breakPoint ? 'left' : 'bottom',
      enabled: (this.$conf.sidebar && this.$conf.sidebar.enabled),
      isActive: window.innerWidth >= breakPoint
    }
  },
  computed: {
    icon () { return this.isActive ? 'close' : 'play' },
    isSearchResultsAvailable () {
      return !!this.$store.getters['parcel']
    }
  },
  watch: {
    position (newValue, oldValue) {
      this.$map.setViewPaddings(this.getPadding())
    },
    isActive (newValue, oldValue) {
      this.$map.setViewPaddings(this.getPadding())
    }
  },
  mounted () {
    this.$map.setViewPaddings(this.getPadding())
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.position = window.innerWidth >= breakPoint ? 'left' : 'bottom'
      })
    })
  },
  methods: {
    toggle () {
      this.isActive = !this.isActive
    },
    getPadding () {
      const padding = {
        left: 0,
        bottom: 0
      }
      padding[this.position] = this.isActive ? dimensions[this.position] : 0
      return padding
    },
    logout () {
      this.$store.dispatch('logout')
        .then(() => {
          this.$router.push('/login')
        })
    }
  }
}

</script>

<style lang="stylus" scoped>

#sidebar
  width: 100vw
  height: 60vh
  position: absolute
  left: 0
  bottom: 0
  margin-bottom: calc(-60vh + 51px)
  z-index: 1002
  transition: 0.3s
  background: white
  box-shadow: 0 0 7px 0 rgba(0, 0, 0, 0.11)
  .sidebar-toggle
    position: absolute
    top: 0
    left: 0
    margin-top: -30px
    margin-left: 10px
    span
      transform: rotate(-90deg)
  &.active
    margin-bottom: 0
    .sidebar-toggle
      margin-top: -30px
  .navbar
    border-bottom: 1px solid #7a7a7a
    z-index: 2
  .title
    padding: 0 6px
    margin: 0
    color: white
    h1
      font-size: 1.6rem
      line-height: 58px
      margin-left: 6px
    span
      font-size: .8rem
      line-height: 2rem
  .navbar-item
    border-left: 1px solid #7a7a7a
    display: flex
    height: 100%
    &:active,
    &:focus,
    &:hover
      background: none
    .icon
      height: auto
  .navbar,
  .navbar-menu,
  .navbar-start,
  .navbar-end
    align-items: stretch
    display: flex
    padding: 0
  .navbar-menu
    background: none
    box-shadow: none
    flex-grow: 1
    flex-shrink: 0
  .navbar-start
    justify-content: flex-start
    margin-right: auto
  .navbar-end
    justify-content: flex-end
    margin-left: auto
  .scroller
    position: absolute
    top: 59px
    bottom: 51px
    width: 100%
    overflow: auto
    > div
      position: relative


@media (min-width: 768px)
  #sidebar
    width: 350px
    height: 100%
    margin-bottom: 0
    margin-left: -350px
    .sidebar-toggle
      left: auto
      right: 0
      margin-top: 10px
      margin-right: -30px
      span
        transform: rotate(0deg)
    &.active
      margin-left: 0
      .sidebar-toggle
        margin-top: 10px
        margin-right: -30px





</style>
